<template>
<div id="record-cut-wrapper" @click.stop>
  <div class="h2 mb-3">{{ $t('records.video_cutting') }}</div>
  <v-btn @click="closeCutWindow" class="close-btn" flat fab>X</v-btn>
  <RecordCutSlider
    :record="record"
    :processing="processing"
    @range-update="updateRange"
  />

  <div class="op-messages text-center">
    <div v-if="processing">
      <div class="loading-indicator center-block"></div>
      <div>{{ $t('records.being_processed') }}</div>
    </div>
  </div>

  <div v-if="!processing" class="text-right mt-4">
    <button
      class="btn btn-primary"
      @click="cutRecord"
      :disabled="cut_btn_disabled"
    >{{ $t('records.cut_record') }}</button>
  </div>
</div>
</template>

<script>
import RecordRepository from '@/repositories/RecordRepository'
import RecordCutSlider from './RecordCutSlider'

export default {
  name: 'RecordCut',
  components: {
    RecordCutSlider,
  },
  props: {
    record: Object,
    processing: Boolean,
  },
  data () {
    return {
      range: { start: 0, stop: 0 },
      cut_btn_disabled: false,
    }
  },
  methods: {
    updateRange (range) {
      this.range = range
    },
    cutRecord () {
      this.cut_btn_disabled = true
      const newDuration = (this.range.stop || this.record.duration) - this.range.start
      const media = this.record.media && this.record.media.find((media) => {
        return media.name === 'vod'
      })
      RecordRepository.cutVideo(
        this.record.id, this.range.start, this.range.stop
      ).then(
        resp => {
          this.cut_btn_disabled = false
          // update vod duration because they want to see new duration in details immediately
          if (media) this.$set(media, 'duration', newDuration)
          this.$emit('cut-started')
        },
        err => {
          err.response.json().then(resp => {
            this.cut_btn_disabled = false
            this.$store.commit('snackbar/show', {
              message: resp.detail || err.message,
              color: 'red',
              timeout: 8000
            })
          })
        }
      )
    },
    closeCutWindow () {
      this.$emit('cancel')
    },
  }, // methods

  beforeDestroy () {
    clearInterval(this.notify_interval)
  }
}
</script>

<style lang="sass">
#record-cut-wrapper
  position: absolute
  width: 100%
  min-height: 100vh
  background-color: #fff
  padding: 15px
  z-index: 3
  .video-js
    margin: auto
  .close-btn
    position: absolute
    top: 0
    right: 0
  img
    max-width: 100%
  .op-messages
    margin-top: 20px
</style>
